// src/lib/sentry.ts
import * as Sentry from '@sentry/react';

export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  
  if (import.meta.env.PROD && dsn) {
    Sentry.init({
      dsn: dsn,
      tracesSampleRate: 0.1,
    });
    console.log('Sentry initialized in production mode');
  } else if (dsn) {
    // Optional: initialize in development but with a lower sample rate
    Sentry.init({
      dsn: dsn,
      tracesSampleRate: 0.0, // Don't sample in development
      enabled: false // Disable in development, only test manually
    });
    console.log('Sentry initialized in development mode (disabled)');
  } else {
    console.log('Sentry not initialized: No DSN provided');
  }
};